/** @format */

export { ProductTrustBlock } from './components/product-trust-block';
